<fieldset>
  <legend *ngIf="header">{{ header }}</legend>
  <ng-content></ng-content>
</fieldset>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵe.html